import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ICustomer, IMachineState, IMachineEnergy, IMachineFromApi, ILabel } from 'app/models';
import { Constants } from '../../config/constants';

import {
  MachineService,
  CustomerService,
  DataEnergyService,
  DataStateService,
  AuthenticationTokenStorageService,
  LabelService,
} from 'app/services';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-home-component',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HomeComponent implements OnInit {
  customer$: Observable<ICustomer> | null = null;
  listOfMachinesFromApi: Array<IMachineFromApi> = [];
  listOfDepartmentsFromApi: Array<ILabel> = [];
  machineEnergy!: Array<IMachineEnergy>;
  machineStates!: Array<IMachineState>;
  customerId: number | null = null;
  selectedTabIndex = 1;
  encodedLoggedUser: string | null = null;
  fabricodePlusPath: string | null = null;

  constructor(
    private readonly constants: Constants,
    private readonly machineService: MachineService,
    private readonly labelService: LabelService,
    private readonly customerService: CustomerService,
    private readonly dataStateService: DataStateService,
    private readonly dataEnergyService: DataEnergyService,
    private readonly storageService: AuthenticationTokenStorageService
  ) { }

  ngOnInit(): void {
    this.fabricodePlusPath = `https://${environment.production ? '' : 'dev.'}fabricode-plus.default-solutions.net`;

    const loggedUser = this.storageService.getLoggedUser();

    this.encodedLoggedUser = btoa(JSON.stringify(loggedUser));

    const { customerId } = loggedUser;
    this.customerId = customerId;

    this.customer$ = this.customerService.findOneCustomer(this.customerId);

    this.machineService
      .findAllMachinesByCustomer(this.customerId)
      .pipe(take(1))
      .subscribe(
        (data) => {
          this.listOfMachinesFromApi = data;
        },
        () => console.error
      );

    this.labelService
      .findAllLabelsByCustomerAndType(
        this.customerId,
        this.constants.DEPARTMENT_LABEL_TYPE,
      )
      .pipe(take(1))
      .subscribe(
        (data) => {
          this.listOfDepartmentsFromApi = data;
        },
        () => console.error
      );

    this.dataStateService
      .findAllMachineStatesByCustomer(this.customerId)
      .pipe(take(1))
      .subscribe(
        (data) => (this.machineStates = data),
        () => console.error
      );

    this.dataEnergyService
      .findAllMachineEnergyByCustomer(this.customerId)
      .pipe(take(1))
      .subscribe(
        (data) => (this.machineEnergy = data),
        () => console.error
      );
  }

  onMachinesAddedOrUpdated(): void {
    if (this.customerId) {
      this.machineService
        .findAllMachinesByCustomer(this.customerId)
        .pipe(take(1))
        .subscribe(
          (data) => (this.listOfMachinesFromApi = data),
          () => console.error
        );
    }
  }

  onMainClick() {
    window.location.reload();
  }
}
